












import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Axios from 'axios';

@Component({ })
export default class AppLoadingComponent extends Vue {

	public showLoading = true;
	public dots = '.';
	public dotIntervalId = 0;
	public loadingProgress = 0;
	public get loadText() {
		return `Загрузка данных${this.dots}`;
	}
	public created() {
		this.dotIntervalId = window.setInterval(() => {
			if (this.dots.length < 3) {
				this.dots += '.';
			} else {
				this.dots = '.';
			}
			if (!this.showLoading) {
				clearInterval(this.dotIntervalId);
			}
		}, 500);
		const totalFetch = 8;
		let loaded = 0;
		const colors = Axios.get('/api/world/colors')
			.then((r) => this.$store.dispatch('updateColors', r.data))
			.then(() => this.calculatedProgress(++loaded, totalFetch));
		const world = Axios.get('/api/world/summary')
			.then((r) => {
				this.$store.dispatch('world/updateSummary', r.data.dayInfo);
				this.$store.dispatch('world/updateHistories', r.data.history);
			})
			.then(() => this.calculatedProgress(++loaded, totalFetch));
		const russia = Axios.get('/api/russia/summary')
			.then((r) => {
				this.$store.dispatch('russia/updateSummary', r.data.dayInfo);
				this.$store.dispatch('russia/updateIsolated', r.data.isolated);
				this.$store.dispatch('russia/updateInfected', r.data.infected);
				this.$store.dispatch('russia/updateArrived', r.data.arrived);
			})
			.then(() => this.calculatedProgress(++loaded, totalFetch));
		const russiaResort = Axios.get('/api/russiaResort/day')
			.then((r) => this.$store.dispatch('russiaResort/updateDayInfo', r.data.dayInfo))
			.then(() => this.calculatedProgress(++loaded, totalFetch));
		const worldDates = Axios.get('/api/world/dates')
			.then((r) => this.$store.dispatch('world/updateAllowedDates', r.data))
			.then(() => this.calculatedProgress(++loaded, totalFetch));
		const russiaDates = Axios.get('/api/russia/dates')
			.then((r) => this.$store.dispatch('russia/updateAllowedDates', r.data))
			.then(() => this.calculatedProgress(++loaded, totalFetch));
		const russiaResortDates = Axios.get('/api/russiaResort/dates')
			.then((r) => this.$store.dispatch('russiaResort/updateAllowedDates', r.data))
			.then(() => this.calculatedProgress(++loaded, totalFetch));
		const russiaRegimeChart = Axios.get('/api/russia/regime')
			.then((r) => this.$store.dispatch('russia/updateRegime', r.data))
			.then(() => this.calculatedProgress(++loaded, totalFetch));
		Promise.all([colors, world, russia, russiaResort, worldDates,
			russiaDates, russiaResortDates, russiaRegimeChart]).then(() => this.showLoading = false);
	}

	private calculatedProgress(val, total) {
		this.loadingProgress = parseInt((val / total * 100).toString(), 10);
	}
}
